<template>
  <div class="hello">
    <h1>It&rsquo;s a crypto <i>thang</i>...</h1>

    <div  >
    <b-card-group deck>


    <b-card title="Calculators"

            class="mb-2">
      <p class="card-text">
        Calculators to help you purchase your bitcoin, altcoins, tokens, or other crypto currencies. How many coins can you purchase with your budget?
      </p>
      <b-list-group flush>
        <b-list-group-item><a href="#/calculators/bitcoin" class="card-link">Bitcoin Calculator</a></b-list-group-item>
        <b-list-group-item><a href="#/calculators/altcoin" class="card-link">Altcoin Calculator</a></b-list-group-item>
    </b-list-group>
    </b-card>

    <b-card title="Paths"

        class="mb-2">
	  <p class="card-text">
	    Find the best way to buy altcoins, bitcoins, or any coins. Which exchanges have the best deals right now? You might be surprised...
	  </p>
	 <b-list-group flush>
        <b-list-group-item><a href="#/paths/altcoin" class="card-link">Altcoin Path Finder</a></b-list-group-item>
     </b-list-group>
	</b-card>

	<b-card title="Social Heat Map"

        class="mb-2">
	  <p class="card-text">
	    Which coins are getting the most social love, PR, tweets, shares, etc? Get in front of the crowd. Which crypto coins are heating up or cooling down?
	  </p>
	    <b-list-group flush>
        <b-list-group-item><span class="card-link">Coming soon...</span></b-list-group-item>
     </b-list-group>
	</b-card>


    </b-card-group>
    </div>

    <div>
    <b-card-group deck>
   		<b-card title="Crypto Market Health" class="mb-2">
   			<iframe src="https://coin360.io/widget/map.html" title="Coin360.io: Cryptocurrency Market State" width="100%" height="100%"></iframe>
   		</b-card>
   	</b-card-group deck>
    </div>

  </div>
</template>

<script>
export default {
  name: '',
  data () {
    return {
      msg: ''
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue